import React from 'react'
import PropTypes from 'prop-types'
import { renderRichText } from '../../../gutenberg/helpers'
import { useInnerBlocks } from '../../../gutenberg/utils'
import { textColor } from '../../util/textColor'

// Styled Components
import { Wrapper, Container, Row, Col } from 'scripts/styled-components'
import { Subtitle, Title, Image, ChildrenContent } from './custom.styled'
import SVG from '../SVGs'

const AccordionModule = ({
  add_decors,
  bg_color,
  anchor_slug,
  subtitle,
  title,
  image,
  children,
}) => {
  const { InnerBlocks, ref } = useInnerBlocks(children, ChildrenContent)

  return (
    <Wrapper
      id={anchor_slug || null}
      className={'dhsv-accordion-module'}
      bgColor={bg_color}
      textColor={textColor(bg_color)}
    >
      <Container padding={'90px 0'} mobilePadding={'50px 0 60px'}>
        <Row>
          <Col size={6}>
            {subtitle && (
              <Subtitle>{renderRichText(subtitle, 'span')}</Subtitle>
            )}

            {title && (
              <Title>
                {renderRichText(title, 'span')}
                {add_decors && <SVG icon={'Line'} type={'theme'} />}
              </Title>
            )}

            {image.url !== null && (
              <Image>
                <img src={image.url} alt={image.alt || image.title} />
                <SVG icon={'BackSpot'} type={'theme'} />
              </Image>
            )}
          </Col>
          <Col size={6}>
            <div ref={ref}>{InnerBlocks}</div>
          </Col>
        </Row>
      </Container>
    </Wrapper>
  )
}

const richTextType = PropTypes.oneOfType([PropTypes.string, PropTypes.node])

AccordionModule.propTypes = {
  add_decors: PropTypes.bool,
  bg_color: PropTypes.string,
  anchor_slug: PropTypes.string,
  subtitle: richTextType,
  title: richTextType,
  image: PropTypes.object,
  children: PropTypes.string,
}

export default AccordionModule
